import { Outlet } from 'react-router-dom';
import { useIsDesktop } from '@scramble/hooks';
import { DesktopNavigation, MobileNavigation } from './sidebar';
import { AppLayoutProps } from './types';
import s from './index.module.scss';

export const AppLayout = ({ footer, children, ...props }: AppLayoutProps): JSX.Element => {
  const isDesktop = useIsDesktop();

  return (
    <div className={s.wrapper}>
      {isDesktop ? <DesktopNavigation {...props} /> : <MobileNavigation {...props} />}
      <main className={s.main}>
        <div className={s.content}>
          {children || <Outlet />}
          {footer}
        </div>
      </main>
    </div>
  );
};
